import { useEffect, useState } from 'react';
import { Facet } from '../shared/Facet';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  STAKEHOLDER_TYPE_STRATEGY_APPROVER,
  STAKEHOLDER_TYPE_STRATEGY_OWNER,
  STRATEGY_APPROVER,
  STRATEGY_OWNER
} from '../shared/AppConstants';

import StakeHolderUserFilter from './StakeHolderUserFilter';

export default function UserFilter(props) {
  const { setParentFilter } = props.commonProps;
  const { selectedValues, refreshDefaultUser, masterUserList, setUserMapFn } =
    props;

  const [selectedUsers, setSelectedUsers] = useState(null);
  const [selectedLabels, setSelectedLabels] = useState(null);

  const [stakeHolderTypes, setStakeHolderTypes] = useState([
    {
      name: STRATEGY_OWNER,
      value: STAKEHOLDER_TYPE_STRATEGY_OWNER,
      checked: false
    },
    {
      name: STRATEGY_APPROVER,
      value: STAKEHOLDER_TYPE_STRATEGY_APPROVER,
      checked: false
    }
  ]);

  const stakeHolderTypeOnChange = (userType) => {
    let userIds = [];
    let itemLabel = [];

    if (selectedUsers) {
      prepareJSONData(selectedUsers, itemLabel, userIds);
      setSelectedLabels(itemLabel);
    }
    const updated = stakeHolderTypes.map((element) => {
      if (userType.name === element.name) {
        return { ...element, checked: !element.checked };
      }
      return element;
    });
    const userTypesSelected = updated
      .filter((e) => e.checked)
      .map((e) => e.value);
    setOnParentData(selectedUsers, userIds, userTypesSelected);
    setStakeHolderTypes(updated);
  };

  function processUsers(selectedUsers) {
    let itemLabel = [];
    let userList = [];

    if (selectedUsers?.length > 0) {
      setSelectedUsers(selectedUsers);
      prepareJSONData(selectedUsers, itemLabel, userList);
      setSelectedLabels(itemLabel);
    } else {
      clearFunction();
      return;
    }
    const userTypesSelected = stakeHolderTypes
      .filter((e) => e.checked)
      .map((e) => e.value);

    setOnParentData(selectedUsers, userList, userTypesSelected);
  }

  function setOnParentData(selectedUsers, userList, userType) {
    const stakeholder = selectedUsers
      ? {
          stakeHolders: selectedUsers,
          stakeHolderTypes: userType,
          stakeHolderIds: userList
        }
      : {};
    setParentFilter?.({ stakeholderFilter: stakeholder });
  }

  function prepareJSONData(stakeHolderList, itemLabel, userList) {
    stakeHolderList.forEach((user) => {
      itemLabel?.push({ parent: user.label });
      userList?.push(user.value.toLowerCase());
    });
  }

  useEffect(() => {
    const stakeholders = selectedValues?.stakeHolders;
    const hasUsers =
      stakeholders?.length > 0 &&
      selectedValues?.stakeHolderIds?.length > 0;

    setStakeHolderTypes((types) =>
      types.map((element) => ({
        ...element,
        checked: !!(
          hasUsers && selectedValues.stakeHolderTypes?.includes(element.value)
        )
      }))
    );
    if (hasUsers) {
      const itemLabel = [];
      prepareJSONData(stakeholders, itemLabel);
      setSelectedUsers(stakeholders);
      setSelectedLabels(itemLabel);
    } else {
      setSelectedUsers(null);
      setSelectedLabels(null);
    }
  }, [selectedValues]);

  function clearFunction() {
    setParentFilter?.({ stakeholderFilter: {} });
    setSelectedUsers(null);
    setSelectedLabels(null);
    setStakeHolderTypes(
      stakeHolderTypes.map((record) => ({ ...record, checked: false }))
    );
  }

  useEffect(() => {
    if (refreshDefaultUser) clearFunction();
  }, [refreshDefaultUser]);

  function removeUserSelection(row) {
    const updated = (selectedUsers ?? []).filter(
      (user) => user.label !== row.label
    );

    processUsers(updated.length > 0 ? updated : null);
  }

  return (
    <Facet>
      <Facet.Item
        id="User_filter"
        title="User Role"
        selectedItems={selectedLabels}
        clearSelection={clearFunction}
        onRemoveItem={removeUserSelection}
      >
        <Grid sx={{ minWidth: 0 }}>
          <Box sx={{ minWidth: 0, width: '100%' }}>
            <StakeHolderUserFilter
              key={masterUserList}
              stakeHolderList={masterUserList}
              setSelectedStakeHolderIds={processUsers}
              setUserMapFn={setUserMapFn}
              commonProps={props.commonProps}
              selectedValues={selectedUsers}
            />
          </Box>
          <Box
            mt={1}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              columnGap: 1.5,
              rowGap: 0.5,
              flexWrap: 'wrap',
              '& .MuiFormControlLabel-root': {
                marginLeft: 0,
                marginRight: 0
              }
            }}
          >
            {stakeHolderTypes.map((user) => {
              return (
                <FormControlLabel
                  key={user.value}
                  label={user.name}
                  control={
                    <Checkbox
                      id={user.value}
                      name={user.value}
                      value={user.value}
                      onChange={() => stakeHolderTypeOnChange(user)}
                      disabled={!(selectedUsers?.length > 0)}
                      checked={user.checked}
                    />
                  }
                />
              );
            })}
          </Box>
        </Grid>
      </Facet.Item>
    </Facet>
  );
}
